import { useMutation } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useRecogCalculateEstimatedCharge = ({ options = {} } = {}) =>
  useMutation(
    ({ params, body }) => recognitionServices.calculateEstimatedCharge(params, body),
    options
  );
